import React, { FC, ReactElement } from "react";
import { Col, Container, Row } from "react-bootstrap";

const PageNotFound: FC = (): ReactElement => {
  return (
    <Container>
      <Row className="mt-4">
        <Col>
          <h1>Page Not Found</h1>
        </Col>
      </Row>
    </Container>
  );
};

export default PageNotFound;
